module.exports = __webpack_public_path__ + "images/gasunie4c803380e9af03734045eec90de2c6fd.png";